module.exports = __webpack_public_path__ + "img/1.81f7af37.png";